export interface IVesselScreening {
    id?: number;
    product?: string;
    loadingTypeId?: number;
    imoNumber?: number;
    vesselName?: string;
     classificationSocietyName?: string;
	 classificationSocietyCode?: string;
	 yearOfBuild?: string;
	 vesselType?: string;
	 vesselStatus?: string;
	 dateOfNextSurvey?: string;
     overagePremiumRate?: string;
     vesselAge?:number;
     loadingType?:string
     clientName?:string;
     clientId?:number;
     isFirstClassAsPerPolicyRules?:boolean;
     enableSanctionScreening?:boolean;
     finscanResultStatus?:string;
     policyId?:number;
     policyNo?:string;

}

export class VesselScreening implements IVesselScreening {
    constructor(
        public id?: number,
        public product?: string,
        public loadingTypeId?: number,
        public imoNumber?: number,
        public vesselName?: string,
        public classificationSocietyName?: string,
        public classificationSocietyCode?: string,
        public yearOfBuild?: string,
        public vesselType?: string,
        public vesselStatus?: string,
        public dateOfNextSurvey?: string,
        public overagePremiumRate?: string,
        public vesselAge?:number,
        public loadingType?:string,
        public clientName?:string,
        public clientId?:number,
        public isFirstClassAsPerPolicyRules?:boolean,
        public enableSanctionScreening?:boolean,
        public  finscanResultStatus?:string,
        public policyId?:number,
        public policyNumber?:string

    ) {

    }

}
